import { render } from "./SelectBlock.vue?vue&type=template&id=99ded5aa"
import script from "./SelectBlock.vue?vue&type=script&lang=js"
export * from "./SelectBlock.vue?vue&type=script&lang=js"

import "./SelectBlock.vue?vue&type=style&index=0&id=99ded5aa&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__